export function groupIntoArrBy<Item, Key>(items: Iterable<Item>, selectKey: (i: Item) => Key): Map<Key, Item[]> {
    const out = new Map<Key, Item[]>()

    for (const item of items) {
        const key = selectKey(item)
        const arr = out.get(key)
        if (arr) {
            arr.push(item)
        } else {
            out.set(key, [item])
        }
    }

    return out
}

export function* map<From, To>(items: Iterable<From>, mapper: (item: From) => To): Iterable<To> {
    for (const item of items) {
        yield mapper(item)
    }
}
